module.exports = __webpack_public_path__ + "static/media/signal-embed.785fc70f.png";